module.exports = __webpack_public_path__ + "static/img/swipe-tip.95d85e4d.gif";